import React from 'react';

const menuItem = (props) => {
  const classes = ['menuItem'];
  if (props.visible === false) {
    classes.push('hidden');
  }
  const method = props.method ? props.method : 'get';

  const inner = (
    <a
      href={props.link}
      data-turbo={props.turbo === false ? 'false' : undefined}
      data-turbo-method={method !== 'get' ? method : undefined}
    >
      {props.children}
    </a>
  );

  return <li className={classes.join(' ')}>{inner}</li>;
};

export default menuItem;
